import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Avisa a aplicação de que o perfil em uso mudou.
 *
 * A troca de perfil recarregava a página inteira (`window.location.reload`) só para que o menu
 * e as telas voltassem coerentes com o grupo novo. O custo era o bootstrap completo do Angular.
 * Quem depende do perfil e não é recriado numa navegação — sidebar e navbar, que ficam fora do
 * `router-outlet` — passa a se atualizar ouvindo este aviso.
 *
 * Precisa ser `providedIn: 'root'`: vários componentes declaram `providers: [UserService]` e
 * ganham instâncias próprias, então o aviso não pode morar lá.
 */
@Injectable({
    providedIn: 'root',
})
export class UserSessionService {
    private perfilAlteradoSubject = new Subject<void>();

    public get perfilAlterado$(): Observable<void> {
        return this.perfilAlteradoSubject.asObservable();
    }

    public notificarPerfilAlterado() {
        this.perfilAlteradoSubject.next();
    }
}
